var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpgradeAcademyLaser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 232 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5757ce;}.cls-2{fill:#48489b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "232 15 0 15 30 0 202 10 232 15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "232 15 0 15 30 30 202 20 232 15"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeAcademyLaser);
export default __webpack_public_path__ + "static/media/upgrade-academy-laser.9f9d9a279d67482d5065be3d5350196d.svg";
export { ForwardRef as ReactComponent };